import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import PatientSearchBar from '../PatientSearchBar';
import MobileDetect from 'mobile-detect';
import Switch from '@material-ui/core/Switch';
import Button from '../../components/Button';
import ProviderSearchBar from '../../components/ProviderSearchBar';
import PDFSingleViewer from '../PDFSingleViewer';
import ImgSingleViewer from '../ImgSingleViewer';
// import DownloadLink from 'react-download-link';
import NoticeDialog from '../../components/DialogModals/NoticeDialog';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  makeS3BlobsRenderable,
  fileSelectHandler,
} from '../../util/fileHandling';
import { fetchAppointmentAttachments } from '../../services/api';
import * as authApi from '../../services/api/auth';

function ApptAttachmentModal(props) {
  const {
    userId,
    viewOnly,
    note = {},
    patient = {},
    open,
    save,
    update,
    onClose,
    classes: {
      actions,
      input,
      modal,
      modalContent,
      selectInput,
      previewImg,
      textCenter,
      btnSpacing,
      customFloatLeft,
      //   attachmentResponsive,
    },
  } = props;
  //const update = this.props.update !== undefined ? this.props.update : ''

  const [currentUser, setCurrentUser] = useState({});
  const [toProvider, setToProvider] = useState({});
  const [fromProvider, setFromProvider] = useState({});
  const [toPatientId, setToPatientId] = useState('');
  const [body, setBody] = useState(note.body);
  const [sendToQwellProviderName, setSendToQwellProviderName] = useState('');
  const [sendToQwellProviderNpi, setSendToQwellProviderNpi] = useState('');
  const [sendToQwell, setSendToQwell] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [images, setImages] = useState([]);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [currentImg, setCurrentImg] = useState('');
  const [popNotice, setPopNotice] = useState('');
  const [state, setState] = React.useState(false);
  const [patientVisibility, setPatientVisibility] = React.useState(false);
  const [imagePreview, setImagePreview] = React.useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [fileDn, setFileDn] = useState([]);

  const myRef = useRef(null);

  useEffect(() => {
    let formattedToProvider = {};
    let formattedFromProvider = {};
    if (note.toProviderId) {
      formattedToProvider = {
        value: note.toProviderId,
        label: note.toProviderName,
      };
    }
    if (note.fromProviderId) {
      formattedFromProvider = {
        value: note.fromProviderId,
        label: note.fromProviderName,
      };
    }
    if (note.sendToQwell) {
      formattedToProvider = { value: 'send-to-qwell', label: 'Send to Qwell' };
    }
    setToProvider(formattedToProvider);
    setFromProvider(formattedFromProvider);
    setToPatientId(patient.id || note.patientId);
    setSendToQwellProviderName(note.sendToQwellProviderName);
    setSendToQwellProviderNpi(note.sendToQwellProviderNpi);
    setSendToQwell(note.sendToQwell);
  }, []);

  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };
  const handleChange = () => {
    if (state) setState(false);
    else setState(true);
  };

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };

  useEffect(() => {
    (async () => {
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);
      if (note.fromProviderName === userId && note.visibility) {
        setState(true);
      }
      if (note.toProviderName === userId && note.visibility) {
        setPatientVisibility(true);
      }
      if (viewOnly) {
        // attaching documents for upload
        const apiResponse = await fetchAppointmentAttachments(note.id);
        setFileDn(apiResponse.data);
        const imageObjects = makeS3BlobsRenderable(apiResponse.data);
        setImages(imageObjects);
        setIsLoading(false);
      }
    })();
  }, []);

  const onFieldChange = e => {
    setValidationErrors({ ...validationErrors, [e.target.name]: false });
    switch (e.target.name) {
      case 'body':
        setBody(e.target.value);
        break;
      case 'sendToQwellProviderName':
        setSendToQwellProviderName(e.target.value);
        break;
      case 'sendToQwellProviderNpi':
        setSendToQwellProviderNpi(e.target.value);
        break;
      default:
        throw Error('unknown field changed');
    }
  };

  const inputPicCallBack = fileObject => {
    setImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2 MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImages([]);
      }
    });
  };

  const validate = () => {
    let valid = true;
    const nextState = {};

    if (!toProvider.id) {
      nextState.toProvider = 'Required';
      valid = false;
    }
    if (!fromProvider.id && !currentUser.isProvider) {
      nextState.fromProvider = 'Required';
      valid = false;
    }
    if (!body) {
      nextState.body = 'Required';
      valid = false;
    }
    if (!sendToQwellProviderName && sendToQwell) {
      nextState.sendToQwellProviderName = 'Required';
      valid = false;
    }
    if (!(toPatientId || patient.id)) {
      nextState.toPatientId = 'Required';
      valid = false;
    }

    setValidationErrors(nextState);
    return valid;
  };

  const onSave = () => {
    save({
      body,
      patientId: toPatientId || patient.id, // this was sort of inexplicable, react is doing something funky that made this necessary
      toProviderId: toProvider.id,
      fromProviderId: currentUser.isAdministrator
        ? fromProvider.id
        : currentUser.isProvider
        ? currentUser.provider.id
        : null,
      sendToQwell,
      sendToQwellProviderName,
      sendToQwellProviderNpi,
      // currentUser,
      attachments: images.map(i => i.dataUrl),
      visibility: state,
      requestingAppt: false,
    });
    onClose();
  };

  const updateNote = () => {
    setPatientVisibility(false);
    update({
      id: note.id,
      visibility: state,
      patientId: toPatientId || patient.id, // this was sort of inexplicable, react is doing something funky that made this necessary
    });
    onClose();
  };

  //   const callSetImage = (event) =>{
  //      setImages([])
  //     fileSelectHandler(
  //       event.target.files,
  //       inputPicCallBack,
  //       ['jpg','jpeg', 'pdf'],
  //       1048576, // 1048576 bytes = 1MBl
  //     )
  //   }

  //   const renderPatient = () =>
  //     viewOnly || patient.id ? (
  //       <TextField
  //         inputProps={{
  //           disabled: true,
  //         }}
  //         label="Patient"
  //         variant="filled"
  //         fullWidth
  //         value={patient.name || note.patientName}
  //         className={selectInput}
  //       />
  //     ) : (
  //         <PatientSearchBar
  //           errorMessage={validationErrors.toPatientId}
  //           onSelect={patient => {
  //             if (patient) {
  //               setValidationErrors({ ...validationErrors, toPatientId: false });
  //               setToPatientId(patient.id);
  //             } else {
  //               setToPatientId(null)
  //             }
  //           }}
  //         />
  //       );

  //   const renderToProvider = () =>
  //     viewOnly ? (
  //       <TextField
  //         inputProps={{
  //           disabled: true,
  //         }}
  //         label="Send To (Provider)"
  //         variant="filled"
  //         fullWidth
  //         value={toProvider.label}
  //         className={selectInput}
  //       />
  //     ) : (
  //         <ProviderSearchBar
  //           label="Send To (Provider)"
  //           name="toProvider"
  //           placeholder="Search for a provider..."
  //           allowSendToQwell
  //           errorMessage={validationErrors.toProvider}
  //           onSelect={provider => {
  //             if (provider) {
  //               setValidationErrors({ ...validationErrors, toProvider: false });
  //               setSendToQwell(provider.id === 'send-to-qwell');
  //             }
  //             setToProvider(provider || {});
  //           }}
  //           className={selectInput}
  //         />
  //       );

  //   const renderFromProvider = () =>
  //     viewOnly ? (
  //       <TextField
  //         inputProps={{
  //           disabled: true,
  //         }}
  //         label="On Behalf Of (Provider)"
  //         variant="filled"
  //         fullWidth
  //         value={fromProvider.label}
  //         className={selectInput}
  //       />
  //     ) : (
  //         <ProviderSearchBar
  //           label="On Behalf Of (Provider)"
  //           name="fromProvider"
  //           placeholder="Search for a provider..."
  //           practiceId="currentUsersPracticeId"
  //           onSelect={provider => {
  //             setValidationErrors({ ...validationErrors, fromProvider: false });
  //             setFromProvider(provider || {});
  //           }}
  //           errorMessage={validationErrors.fromProvider}
  //           className={selectInput}
  //         />
  //       );

  /* Helper function */
  const download_file = (fileURL, fileName) => {
    // for non-IE
    if (!window.ActiveXObject) {
      var save = document.createElement('a');
      save.href = fileURL;
      save.target = '_blank';
      var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
      save.download = fileName || filename;
      if (
        navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
        navigator.userAgent.search('Chrome') < 0
      ) {
        document.location = save.href;
        // window event not working here
      } else {
        var evt = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    }
    // for IE < 11
    else if (!!window.ActiveXObject && document.execCommand) {
      var _window = window.open(fileURL, '_blank');
      _window.document.close();
      _window.document.execCommand('SaveAs', true, fileName || fileURL);
      _window.close();
    }
  };

  const base64ToArrayBuffer = base64 => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  const saveByteArray = (reportName, byte) => {
    var blob = new Blob([byte], { type: 'application/octet-stream' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  };

  const downloadAll = async () => {
    images.forEach((element, index) => {
      var link = document.createElement('a');
      link.download = 'attachment';
      link.target = '_blank';
      // Construct the URI
      link.href = element.dataUrl;
      document.body.appendChild(link);
      setTimeout(function() {
        link.click();
        // Cleanup the DOM
        document.body.removeChild(link);
      }, 500 * index);
    });
    // var link = document.createElement('a');

    // link.setAttribute('download', 'attachments');
    // link.dispatchEvent(new MouseEvent('click'));
    // link.style.display = 'none';

    // document.body.appendChild(link);

    // for (var i = 0; i < images.length; i++) {
    //   link.setAttribute('href', images[i].dataUrl);
    //   link.click();
    // }
    // document.body.removeChild(link);

    // try {
    //   for (let i = 0; i < fileDn.length; i++) {

    //     const sampleArr = base64ToArrayBuffer(fileDn[i].Body.data);
    //     saveByteArray("Sample Report", sampleArr);
    //     // download_file(images[i].dataUrl, 'attachments');
    //     // if (fileDn[i].fileType === 'pdf') {
    //     //   base64toPDF(fileDn[i].Body.data);
    //     // }
    //   }
    // } catch (error) {
    //   console.log('error', error);
    // }
  };

  const md = new MobileDetect(window.navigator.userAgent);
  const isMobile = md.mobile();
  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={onClose}
        classes={{ paper: modal }}
        maxWidth={'xl'}
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={11}>
              <h2>
                Attachments {!viewOnly ? 'a Doc' : ''}{' '}
                {patientVisibility ? '(Message visible to Patient)' : ''}
              </h2>
            </Grid>

            <Grid item xs={1}>
              <IconButton aria-label="Close" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        {isLoading ? (
          <div className={props.classes.loading}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <div className="attachmentView paddingZero">
              <DialogContent classes={{ root: modalContent }}>
                {images && images.length == 0 ? (
                  <div>{images.length} images attached</div>
                ) : (
                  images.map((image, index) =>
                    image?.fileType === 'pdf' ? (
                      <>
                        <div className={btnSpacing}>
                          <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                          <Button
                            color="primary"
                            disabled={
                              image?.fileType === 'htm' ||
                              image?.fileType === 'html;base6'
                            }
                            variant="contained"
                            onClick={() => handleOpenPDF(image.dataUrl)}
                          >
                            Click To Preview
                          </Button>
                          {/* <div>To see full report, please click download all button</div> */}
                        </div>
                        {/* <Document file={image.dataUrl} options={options} className={previewImg}>
                                                <Page pageNumber={1} />
                                              </Document> */}

                        <PDFSingleViewer
                          openPDFModal={openPDFModal}
                          //   pdfRes={attachmentResponsive}
                          currentPDF={currentPDF}
                          onClose={() => setOpenPDFModal(false)}
                        />
                      </>
                    ) : (
                      <Grid container className={customFloatLeft} item xs={6}>
                        <Grid className={btnSpacing} item xs={12}>
                          <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                          <Button
                            color="primary"
                            // disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6'}
                            variant="contained"
                            onClick={
                              image?.fileType === 'htm' ||
                              image?.fileType === 'html' ||
                              image?.fileType === 'html;base6'
                                ? null
                                : () => handleOpenImg(image.dataUrl)
                            }
                          >
                            {image?.fileType === 'htm' ||
                            image?.fileType === 'html' ||
                            image?.fileType === 'html;base6'
                              ? 'Html File'
                              : '   Click to enlarge'}
                          </Button>
                          {/* <Button
                                                            color="primary"
                                                            disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' }
                                                            variant="contained"
                                                            onClick={() => handleOpenImg(image.dataUrl)}
                                                        >
                                                            Click to enlarge
                                                            </Button> */}
                          {image?.fileType === 'htm' ||
                          image?.fileType === 'html' ||
                          image?.fileType === 'html;base6' ? (
                            <div>
                              To see full report, please click download all
                              button
                            </div>
                          ) : (
                              <div className="imgCenter">
                            <img
                              src={image && image.dataUrl}
                              key={`picture-${index}`}
                              className={previewImg}
                            />
                            </div>
                          )}
                          {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} className={previewImg} /> */}
                          {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} alt="To see full report, please download the file" className={previewImg} /> */}
                          {/* <img src={image.dataUrl} key={`picture-${index}`} alt="preview" className={previewImg} /> */}
                          <ImgSingleViewer
                            openImgModal={openImgModal}
                            currentImg={currentImg}
                            onClose={() => setOpenImgModal(false)}
                          />
                        </Grid>
                        {/* <img src={image && image.dataUrl} key={`picture-${index}`} onError={() => setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} /> */}

                        {/* <img src={image && image.dataUrl} style={{ display: 'none' }} key={`picture-${index}`} onError={() => setImagePreview(false)} alt="To see full report, please download the filesssss" className={previewImg} /> */}
                        {/* <ImgSingleViewer
                                                        openImgModal={openImgModal}
                                                        currentImg={currentImg}
                                                        onClose={() => setOpenImgModal(false)}
                                                    /> */}
                      </Grid>
                    )
                  )
                )}
                {images && images.length > 0 && (
                  //s <a className="custom-attachment-btn popup-download-btn" target='_blank' href={image && image.dataUrl} download >VIEW ATTACHMENT {index +1}</a>

                  <Grid container item xs={12}>
                    <button
                      className="custom-download-all-btn custom-attachment-btn popup-download-btn"
                      onClick={() => downloadAll()}
                    >
                      Download All
                    </button>
                    {/* <DownloadLink
                      label="Download All"
                      filename="attachment"
                    //   style="custom-download-all-btn custom-attachment-btn popup-download-btn"
                      exportFile={() => Promise.resolve(downloadAll())}
                    /> */}
                  </Grid>
                )}
                {/* <a className="custom-popup-download-btn" target='_blank' href={images} download >Download</a> */}
              </DialogContent>
            </div>
          </>
        )}

        {/* <DialogTitle>
                    <Grid container alignItems="center">
                        <Grid item xs={11}>
                            <h2>Attachments {!viewOnly ? 'a Doc' : ''} {patientVisibility ? '(Message visible to Patient)' : ''}</h2>
                        </Grid>

                        <Grid item xs={1}>
                            <IconButton aria-label="Close" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent classes={{ root: modalContent }}>
                    

                   

              
                    {images &&
                        images.length > 0 && isMobile && !viewOnly ?
                        <div>{images.length} images attached</div> :
                        images.map((image, index) => image ?.fileType === 'pdf' ? (
                            <>
                                <div  >
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={() => handleOpenPDF(image.dataUrl)}
                                    >
                                        Click to Preview
                  </Button>
                                    <a className="custom-popup-download-btn" target='_blank' href={image && image.dataUrl} download >Download</a>
                                </div>
                                
                                <PDFSingleViewer
                                    openPDFModal={openPDFModal}
                                    currentPDF={currentPDF}
                                    onClose={() => setOpenPDFModal(false)}
                                />
                            </>
                        ) : (
                                <Grid container item xs={12}>
                                    <Grid item xs={12}>
                                        <Button
                                            disabled={image ?.fileType === 'htm' || image ?.fileType === 'html'}
                                            //disabled={!imagePreview}
                                            color="primary"
                                            variant="contained"
                                            onClick={() => handleOpenImg(image.dataUrl)}
                                        >
                                            Click to Preview
                  </Button>
                                        <a className="custom-popup-download-btn" target='_blank' href={image && image.dataUrl} download >Download</a>

                                    </Grid>

                                    <img src={image && image.dataUrl} style={{ display: 'none' }} key={`picture-${index}`} onError={() => setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} />
                                    <ImgSingleViewer
                                        openImgModal={openImgModal}
                                        currentImg={currentImg}
                                        onClose={() => setOpenImgModal(false)}
                                    />
                                </Grid>
                            )
            )
                    }

                    <Grid container classes={{ container: actions }}>
                        {(!viewOnly || (note && note.fromProviderName === userId) && userId !== undefined) &&
                            <Grid item xs={12} lg={12}>
                                <Button className="custom-update-btn"
                                    disabled={false}
                                    fullWidth
                                    color="primary"
                                    variant="contained"
                                    onClick={note && note.fromProviderName === userId && userId !== undefined ? updateNote : onSave}
                                    onClickValidation={note && note.fromProviderName === userId && userId !== undefined ? '' : validate}
                                >
                                    {note && note.fromProviderName === userId && userId !== undefined ? 'Update Note' : 'Send Note'}
                                </Button>
                            </Grid>
                        }
                    </Grid>
                </DialogContent> */}
      </Dialog>
      {popNotice && (
        <NoticeDialog
          open={popNotice}
          onOkClick={() => setPopNotice('')}
          noticeTitle="Notice"
          message={popNotice}
        />
      )}
    </>
  );
}

ApptAttachmentModal.propTypes = {
  viewOnly: PropTypes.bool,
  note: PropTypes.object,
  patient: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
    maxWidth: '700px !important',
  },
  btnSpacing: {
    marginBottom: '15px',
  },
  textCenter: {
    textAlign: 'center',
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
    marginBottom: '1em',
    marginTop: '1em',
    width: 300, 
    height: 300,
  },
  customFloatLeft: {
    width: '50%',
    display: 'inline-block',
  },
  attachmentResponsive: {
    width: 'auto',
  },
});

export default withStyles(styles)(ApptAttachmentModal);

//  <Grid container item xs={12}>
// <Grid item xs={12}>
//   <Button
//     color="primary"
//     variant="contained"
//     onClick={() => handleOpenImg(image.dataUrl)}
//   >
//     Click to enlarge
// </Button>
// </Grid>
// <img src={image.dataUrl} key={`picture-${index}`} alt="preview" className={previewImg} />
// <ImgSingleViewer
//   openImgModal={openImgModal}
//   currentImg={currentImg}
//   onClose={() => setOpenImgModal(false)}
// />
// </Grid>

//<a className="custom-popup-download-btn" target='_blank' href={image && image.dataUrl} download >Download</a>
